import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

import type * as GraphQLTypes from '../../../graphql/types.generated';
const defaultOptions = {} as const;

export type UpdateMemberBusinessUnitsMutationVariables = GraphQLTypes.Exact<{
  input: GraphQLTypes.UpdateAccountMemberBusinessUnitsInput;
}>;

export type UpdateMemberBusinessUnitsMutationResult = { __typename?: 'Mutation' } & {
  updateAccountMemberBusinessUnits?: GraphQLTypes.Maybe<
    { __typename?: 'UpdateAccountMemberBusinessUnitsPayload' } & {
      errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message' | 'path'>>>;
    }
  >;
};

export const UpdateMemberBusinessUnitsDocument = /*#__PURE__*/ gql`
  mutation updateMemberBusinessUnits($input: UpdateAccountMemberBusinessUnitsInput!) {
    updateAccountMemberBusinessUnits(input: $input) {
      errors {
        message
        path
      }
    }
  }
`;

/**
 * __useUpdateMemberBusinessUnitsMutation__
 *
 * To run a mutation, you first call `useUpdateMemberBusinessUnitsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMemberBusinessUnitsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMemberBusinessUnitsMutation, { data, loading, error }] = useUpdateMemberBusinessUnitsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMemberBusinessUnitsMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateMemberBusinessUnitsMutationResult, UpdateMemberBusinessUnitsMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<UpdateMemberBusinessUnitsMutationResult, UpdateMemberBusinessUnitsMutationVariables>(
    UpdateMemberBusinessUnitsDocument,
    options
  );
}
export type UpdateMemberBusinessUnitsMutationHookResult = ReturnType<typeof useUpdateMemberBusinessUnitsMutation>;
